__turbopack_context__.v({
  "frame": "SnapTradePortal-module__PEXsRa__frame",
  "frameShell": "SnapTradePortal-module__PEXsRa__frameShell",
  "loading": "SnapTradePortal-module__PEXsRa__loading",
  "portal": "SnapTradePortal-module__PEXsRa__portal",
});
